import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Autoplay, EffectFade, Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/effect-fade';
import 'swiper/css/navigation';
import {Box} from '@mui/material';
import { CustomIconButton } from '../../shared/utils/CustomIcon';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import useImageStore from '../../shared/store/useImageStore';
import { ImagePath } from '../../shared/constants';

const EventCarousel = ({ slides }) => {
    const { id } = useParams();
    const { isImgLoading, setIsImgLoading } = useImageStore();
    useEffect(() => {
        setIsImgLoading(true);
        const timer = setTimeout(() => {
            setIsImgLoading(false);
        }, 3);

        return () => clearTimeout(timer);
    }, [id]);
    return (
        <Box sx={{ "& .swiper-pagination": { display: "none !important" } }}>
            <Swiper
                modules={[Pagination, Autoplay, EffectFade, Navigation]}
                effect="fade"
                spaceBetween={10}
                slidesPerView={1}
                pagination={{ clickable: true }}
                autoplay={{ delay: 3000, disableOnInteraction: false }}
                loop
                navigation={{ nextEl: ".custom-swiper-next", prevEl: ".custom-swiper-prev" }}
                style={{
                    borderRadius: "40px",
                    display: isImgLoading ? "none" : "block",
                }}
                onLoad={() => setIsImgLoading(false)}
                onError={() => setIsImgLoading(false)}
            >
                {slides.map((slide, index) => (
                    <SwiperSlide key={index}>
                        <Box
                            sx={{
                                position: "relative",
                                height: { xs: "200px", sm: "260px", lg: "400px" },
                                backgroundImage: `url(${ImagePath}be_events/assets/admin/img/event-gallery/${slide})`,
                                backgroundSize: "cover",
                                backgroundPosition: "center",
                                px: 2,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                borderRadius: "40px",
                            }}>
                            <Box sx={{ display: 'flex', justifyContent: "space-between", width: "100%" }}>
                                <CustomIconButton className="custom-swiper-prev" icon={<ArrowBackIcon sx={{ color: "red.main", fontSize: "20px" }} />} bgcolor={"primary.main"} />
                                <CustomIconButton className="custom-swiper-next" icon={<ArrowForwardIcon sx={{ color: "red.main", fontSize: "20px" }} />} bgcolor={"primary.main"} />
                            </Box>
                        </Box>
                    </SwiperSlide>
                ))}
            </Swiper>
        </Box>

    )
}

export default EventCarousel